/**
 * @description: 首次下单必点商品设置
 * @author: lyr
*/
<template>
    <div class="commodity-must-order">
        <div class="list" v-show="showList">
            <el-form :inline="true" :model="list_form">
				<el-form-item label="门店">
					<el-select v-model="list_form.shop_id" filterable placeholder="请选择门店" @change="onShopChange">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="适用包厢">
	                <el-select v-model="list_form.room_id" filterable clearable placeholder="请输入包厢号">
	                    <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
	                </el-select>
	            </el-form-item>
	            <el-form-item label="包厢类型">
	                <el-select v-model="list_form.room_type" filterable clearable placeholder="请选择包厢类型">
	               		<el-option value="" label="全部"></el-option>
	                    <el-option v-for="item in room_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
	                </el-select>
	            </el-form-item>
	            <el-form-item label="状态">
	                <el-select v-model="list_form.status" clearable placeholder="请选择状态">
	                    <el-option value="" label="全部"></el-option>
	                    <el-option value="1" label="启用"></el-option>
	                    <el-option value="-1" label="禁用"></el-option>
	                </el-select>
	            </el-form-item>
	            <el-form-item label="必点商品">
	                <el-input v-model="list_form.goods_name" placeholder="请输入商品名称" clearable></el-input>
	            </el-form-item>
				<el-form-item class="pull-right">
					<el-button type="primary" @click="getList(1)">查询</el-button>
					<el-button type="primary" @click="addNewRule">新增规则</el-button>
				</el-form-item>
			</el-form>
            <el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:header-cell-style="{'text-align':'center'}"
				:cell-style="{'text-align':'center'}"
				:data="list_table">
				<el-table-column prop="listorder" label="优先级"></el-table-column>
				<el-table-column prop="room_name" label="适用包厢">
					<template slot-scope="scope">
                        <el-popover
                            placement="right"
                            title="适用包厢"
                            trigger="hover"
                            width="500">
                            <p>{{scope.row.room_name}}</p>
                            <p slot="reference">{{scope.row.room_name.split(',').length > 5 ? scope.row.room_name.split(',').slice(0, 5).join(',') + '...' : scope.row.room_name}}</p>
                        </el-popover>
                    </template>
				</el-table-column>
                <el-table-column prop="room_type" label="包厢类型"></el-table-column>
                <el-table-column prop="week_cycle_info" label="有效星期几"></el-table-column>
                <el-table-column prop="use_time" label="使用时间"></el-table-column>
                <el-table-column prop="goods_str" label="必点商品" width="250"></el-table-column>
                <el-table-column prop="status" label="状态">
	                <template slot-scope="scope">{{scope.row.status == '1' ? '启用' : '禁用'}}</template>
                </el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="text-blue" @click="updateStatus(scope.row.id, '1')" v-if="scope.row.status == '-1'">启用</span>
						<span class="text-blue" @click="updateStatus(scope.row.id, '-1')" v-if="scope.row.status == '1'">禁用</span>
						<span class="text-blue" @click="checkDetail(scope.row.id)">详情</span>
						<span class="text-blue" @click="editRule(scope.row.id)">修改</span>
						<span class="text-blue" @click="updateStatus(scope.row.id, '-2')">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="list_page"
				:total="list_total"
				@current-change="getList">
			</el-pagination>
        </div>
        <!-- 新增、修改规则 -->
        <div class="add-panel" v-show="!showList&&!showBox&&!showPickGoods">
        	<h2>{{modify == '' ? '新增必点商品规则' : modify == 1 ? '修改必点商品规则' : '必点商品规则详情'}}</h2>
        	<el-form v-model="add_form" label-width="100px">
				<el-form-item label="门店">
					<el-select v-model="add_form.shop_id" filterable placeholder="请选择门店" disabled>
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="优先级">
					<el-input v-model="add_form.listorder" placeholder="请输入规则优先级：例如01、02、03，数值大的优先" clearable :disabled="modify==2"></el-input>
				</el-form-item>
				<el-form-item label="适用包厢">
					<el-input v-model="room_ids_str" placeholder="请选择包厢号" clearable @focus="openRoomPanel" @clear="clearRoomIds" :disabled="room_types_str!=''||modify==2"></el-input>
				</el-form-item>
				<el-form-item label="包厢类型">
					<el-input v-model="room_types_str" placeholder="请选择包厢类型" clearable @focus="openRoomTypePop" @clear="clearRoomTypes" :disabled="room_ids_str!=''||modify==2"></el-input>
				</el-form-item>
				<el-form-item label="使用时间">
					<el-input v-model="use_time_str" placeholder="请选择使用时间" clearable @focus="openUseTimePop" @clear="clearUseTime" :disabled="modify==2"></el-input>
				</el-form-item>
				<el-form-item label="有效星期几">
					<el-input v-model="week_str" placeholder="请选择有效星期几" clearable @focus="openWeekPop" @clear="clearWeek" :disabled="modify==2"></el-input>
				</el-form-item>
				<el-form-item label="必点商品">
					<el-input v-model="goods_name_str" placeholder="请选择必点商品" clearable @focus="openPickGoodsPanel" @clear="clearPickGoods" :disabled="modify==2"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="showList=true">返回</el-button>
					<el-button type="primary" @click="commit" :disabled="modify==2">确定</el-button>
				</el-form-item>
        	</el-form>
		</div>
    	<!-- 包厢号 -->
		<div class="multi-page box-page" ref="box_area" v-show="showBox">
			<div class="page-tit">选择包厢</div>
			<ul class="box-type clearfix">
				<el-button :type="get_room_by==1?'primary':''" @click="getRoomByChange(1)">按包厢区域显示</el-button>
				<el-button :type="get_room_by==2?'primary':''" @click="getRoomByChange(2)">按包厢类型显示</el-button>
			</ul>
			<p>请选择包厢范围</p>
			<div class="multi-page-main">
				<div class="multi-page-row">
					<div>
						<input type="checkbox" v-model='box_all' @click='boxAll'>
						<span>全部包厢</span>
					</div>
					<ul></ul>
				</div>
				<div class="multi-page-row" v-for="(items, index) in box_arr" :key="items.room_area">
					<div>
						<input type="checkbox" v-model='box_floor' :value="items.room_area" @click="boxFloor(items.room_area, index)">
						<span>{{items.room_area_name}}</span>
					</div>
					<ul class="clearfix">
						<li v-for="item in items.room" :key="item.id">
							<input type="checkbox" v-model='box_item' :value="item.id">
							<span>{{item.name}}</span>
						</li>
					</ul>
				</div>
			</div>
			<div class="row">
				<el-button @click="boxBackEdit">返回</el-button>
				<el-button type="primary" @click="saveBox">确定</el-button>
			</div>
        </div>
        <!--包厢类型弹窗-->
		<div class="ele-hide" ref="boxtype_pop">
			<div class="multi-select">
				<div class="clearfix">
					<li>
						<input type='checkbox' v-model='boxtype_all' @click='boxtypeAll'>
						<label>全选</label>
					</li>
				</div>
				<ul class="clearfix">
					<li v-for="item in room_type_list" :key="item.id">
						<input type="checkbox" v-model='boxtype_item' :value="item.id">
						<label>{{item.name}}</label>
					</li>
				</ul>
			</div>
		</div>
		<!-- 使用时间弹窗 -->
		<div class="use-time-wrap ele-hide" ref="usetime_pop">
			<h2>开始时间：</h2>
			<el-row>
				<el-col :span="11">
					<el-select v-model="hour_start" filterable>
						<el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-col>
				<el-col class="el-line" :span="2">:</el-col>
				<el-col :span="11">
					<el-select v-model="minute_start" filterable>
						<el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-col>
			</el-row>
			<h2>结束时间：</h2>
			<el-row>
				<el-col :span="11">
					<el-select v-model="hour_end" filterable>
						<el-option v-for="item in GLOBAL.HOURLIST" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-col>
				<el-col class="el-line" :span="2">:</el-col>
				<el-col :span="11">
					<el-select v-model="minute_end" filterable>
						<el-option v-for="item in GLOBAL.MINUTELIST" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-col>
			</el-row>
		</div>
		<!-- 星期几弹窗 -->
		<div class="week-pop ele-hide" ref="week_pop">
			<el-checkbox :indeterminate="week_sign" v-model="week_all" @change="weekAll">全选</el-checkbox>
			<el-checkbox-group v-model="week_ids" @change="weekChange">
				<el-checkbox label="1">星期一</el-checkbox>
				<el-checkbox label="2">星期二</el-checkbox>
				<el-checkbox label="3">星期三</el-checkbox>
				<el-checkbox label="4">星期四</el-checkbox>
				<el-checkbox label="5">星期五</el-checkbox>
				<el-checkbox label="6">星期六</el-checkbox>
				<el-checkbox label="0">星期日</el-checkbox>
			</el-checkbox-group>
		</div>
		<!-- 商品选择面板 -->
		<div class="good-pick-panel" v-show="showPickGoods">
			<el-button type="primary" @click="savePickGoods">确定</el-button>
			<el-button type="primary" @click="openPickGoodsPop">添加商品</el-button>
			<h2>必点商品选择</h2>
			<el-table
				class="panel-table"
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:header-cell-style="{'text-align':'center'}"
				:cell-style="{'text-align':'center'}"
				:data="panel_table">
				<el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
				<el-table-column prop="good_img" label="商品图片">
					<template slot-scope="scope">
						<img :src="scope.row.good_img" alt="">
					</template>
				</el-table-column>
                <el-table-column prop="goods_name" label="商品名称"></el-table-column>
                <el-table-column prop="goods_unit_name" label="商品单位"></el-table-column>
                <el-table-column prop="quantity" label="数量">
					<template slot-scope="scope">
						<el-input v-model="scope.row.quantity" placeholder="请输入数量"></el-input>
					</template>
                </el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<span class="text-blue" @click="delGoods(scope.row, scope.$index)">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="panel_page"
				:total="panel_total"
				@current-change="getPanelTable">
			</el-pagination>

			<!-- 商品选择弹窗 -->
			<div class="good-pick-pop ele-hide" ref="good_pick_pop">
				<el-form :inline="true">
					<el-form-item>
						<el-select v-model="goods_type_name" filterable clearable placeholder="请选择商品类型" @change="goodsTypeChange($event)">
		                    <el-option v-for="item in goods_type_list" :key="item.id" :label="item.name" :value="item"></el-option>
		                </el-select>
					</el-form-item>
					<el-form-item>
						<el-input v-model="goods_name" clearable placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-button type="primary" @click="getPopGoodsTable(1)">查询</el-button>
				</el-form>
				<el-table
					v-loading="pop_loading"
					element-loading-text="努力加载中，请稍后..."
					element-loading-background="rgba(0, 0, 0, 0.6)"
					ref="pop_table"
					:data="pop_table"
					@selection-change="getSelectGoods">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="goods_type_name" label="类型"></el-table-column>
					<el-table-column
						v-for="(item, index) in goods_columns"
						:key="index"
						:prop="item.prop"
						:label="item.label">
					</el-table-column>
				</el-table>
				<el-pagination
					background
					layout="total, prev, pager, next, jumper"
					:page-size="GLOBAL.PAGESIZEMINI"
					:current-page.sync="pop_page"
					:total="pop_total"
					@current-change="getPopGoodsTable">
				</el-pagination>
			</div>
		</div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'commodity-must-order',
        data() {
            return {
                showList: true,
                shop_list: [],
                room_list: [],
                room_type_list: [],
				list_form: {
                    shop_id: '',
                    room_id: '',
                    room_type: '',
                    status: '', //1启用 -1禁用
                    goods_name: ''
				},
                loading: false,
				list_page: 1,
				list_total: 0,
				list_table: [],
				add_form: {
					id: '',
					start_time: '',
					end_time: '',
					shop_id: '',
					listorder: '',
					goods_info: [],
					all_room_ids: '-1', //是否适用所有包厢 1是 -1否
					room_ids: [],
					all_room_types: '-1', //是否适用所有包厢类型  1是 -1否
					room_types: [],
					week_cycle: '',
				},
				room_ids_str: '',
				room_types_str: '',
				goods_name_str: '',

				showBox: false, // 显示包厢号选择面板
				get_room_by: 1, // 1按包厢区域 2按照包厢类型
				c_get_room_by: 1,
				box_all: false,
				c_box_all: false,
				box_item: [],
				c_box_item: [],
				box_floor: [],
				c_box_floor: [],
				box_arr: [],
				box_arr_det: [],

				boxtype_all: false,
				c_boxtype_all: false,
				boxtype_item: [],

				use_time_str: '',
				hour_start: '00',
                minute_start: '00',
                hour_end: '00',
                minute_end: '00',

                week_list: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],
                week_sign: false,
				week_all: false,
				week_ids: [],
				week_str: '',

				showPickGoods: false, // 显示商品选择面板
				panel_total: 0,
				panel_page: 1,
				panel_table: [],

				pop_loading: false,
				pop_page: 1, // 商品弹窗页码
				pop_total: 0,
				pop_table: [],
				goods_type_list: [], // 商品类型列表
				goods_type_sign: '',
				goods_type: '',
				goods_type_name: '',
				goods_name: '',
				goods_columns: [],
				goods_table_select: [], // 商品弹窗选择的商品
				goods_select: [], // 选择的商品
				modify: '', //1修改 2详情 ''新增
            }
		},
		watch: {
			box_item: {
				handler: function(val, oldVal) {
					let _this = this;

					if(_this.box_item.length >= _this.box_arr_det.length) {
						_this.box_all = true;
						_this.c_box_all = _this.box_all;
					} else {
						_this.box_all = false;
						_this.c_box_all = _this.box_all;
					}

					$.each(_this.box_arr, function(k, v) {
						if(_this.box_item.length >= v.room.length) {
							let num = 0;
							for(let i = 0, len = v.room.length; i < len; i++) {
								if(_this.box_item.indexOf(v.room[i].id) != -1) {
									num++;
								}
								if(i == v.room.length - 1 && num == v.room.length) {
									if(_this.box_floor.indexOf(v.room_area) == -1) {
										_this.box_floor.push(v.room_area);
									}
								} else {
									let index = '';
									index = _this.box_floor.indexOf(v.room_area);
									if(index != -1) {
										_this.box_floor.splice(index, 1);
									}
								}
							}
						} else {
							let index = '';
							index = _this.box_floor.indexOf(v.room_area);
							if(index != -1) {
								_this.box_floor.splice(index, 1);
							}
						}
					});
					_this.c_box_floor = _this.box_floor;
				},
				deep: true
			},
			boxtype_item: {
				handler: function (val, oldVal) {
					if(this.boxtype_item.length >= this.room_type_list.length) {
						this.boxtype_all = true;
						this.c_boxtype_all = this.boxtype_all;
					} else {
						this.boxtype_all = false;
						this.c_boxtype_all = this.boxtype_all;
					}
				},
				deep: true
			},
		},
		computed: {

		},
        mounted: function() {
			new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getRoom(this.list_form.shop_id)
                this.getRoomType(this.list_form.shop_id)
				this.getBoxNum(this.list_form.shop_id, this.get_room_by)
                this.getList(1);
            })
        },
        methods: {
            // 获取门店数据
			getShop: function(resolve) {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
						_this.shop_list.shift();
						resolve()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},

			onShopChange(val) {
				if (!!val) {
					this.room_id = ''
                    this.room_type = ''
					this.getRoom(this.list_form.shop_id)
	                this.getRoomType(this.list_form.shop_id)
					this.getBoxNum(this.list_form.shop_id, this.get_room_by)
				}
			},

			// 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;
                
                Vue.axios.post('Shop/getAllRoom', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_list = res.data.response.result;
                        _this.room_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取包厢类型
            getRoomType: function(shop_id) {
                const _this = this;
                Vue.axios.post('PublicData/api_getRoomType', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_type_list = res.data.response.result.data;
                        // _this.room_type_list.unshift({
                        //     id: '',
                        //     name: '全部'
                        // })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
				_this.page = page
				Vue.axios.post('MustOrderItems/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"shop_id": _this.list_form.shop_id,
                            "room_id": _this.list_form.room_id,
                            "room_type": _this.list_form.room_type,
                      		"status": _this.list_form.status,
                            "goods_name": _this.list_form.goods_name,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total)
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			// 更新状态
	        updateStatus(id, status) {
	            let _this = this 
	            let title = status == '-1' ? '是否禁用？': status == '1' ?'是否启用？' : '删除后数据将不可恢复！确认删除？'

	            layer.confirm(title, {
	                btn: ['确定', '取消'],
	                title: '提示',
	            }, function() {
	                Vue.axios.post('MustOrderItems/upStatus', {
	                    "header": Vue.request_header,
	                    "request": {
	                        "param": {
	                            "id": id,
	                            "status": status
	                        }
	                    },
	                    "comment": ""
	                })
	                .then(res => {
	                    layer.closeAll()
	                    if(res.data.response.result_code == "true") {
	                        layer.msg('操作成功');
	                        _this.getList(_this.page);
	                    } else {
	                        Vue.timeoutfun(res.data.response.result_status, _this);
	                        layer.msg(res.data.response.error_msg);
	                    }
	                })
	                .catch(err => {
	                    layer.msg('出错啦');
	                });
	            });
	        },

	        // 点击“新增规则”
	        addNewRule() {
	        	this.modify = ''
	        	this.add_form = {
					id: '',
					start_time: '',
					end_time: '',
					shop_id: this.list_form.shop_id,
					listorder: '',
					goods_info: [],
					all_room_ids: '-1', //是否适用所有包厢 1是 -1否
					room_ids: [],
					all_room_types: '-1', //是否适用所有包厢类型  1是 -1否
					room_types: [],
					week_cycle: '',
				}
				this.showList = false
				// 包厢
				this.get_room_by = 1
				this.getBoxNum(this.add_form.shop_id, this.get_room_by)
				this.room_ids_str = ''
				this.box_item = []
				this.add_form.all_room_ids = '-1'
				// 包厢类型
				this.room_types_str = ''
				this.boxtype_item = []
				this.add_form.all_room_types = '-1'
				// 使用时间
				this.use_time_str = '08:00-08:00'
				this.add_form.start_time = '08:00'
				this.add_form.end_time = '08:00'
				// 星期几
				this.week_sign = false
                this.week_all = true
				this.week_ids = ['1','2','3','4','5','6','0']
				this.week_str = '一,二,三,四,五,六,日'
				this.add_form.week_cycle = this.week_ids.join(",")
				// 必点商品
				this.goods_name_str = ''
				this.panel_table = []
				this.goods_select = []
	        },

	        openRoomPanel() {
	        	this.c_room_type = this.room_type;
				this.c_box_item = this.box_item;
				this.c_box_all = this.box_all;
	        	this.showBox = true
	        },

	        // 包厢号数据
			getBoxNum: function(shop_id, type) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"type": type,
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "Shop/getAllRoomByArea",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.box_arr = data.response.result;
							let newarray = [];
							$.each(data.response.result, function(k, v) {
								$.each(v.room, function(m, n) {
									newarray.push(n);
								});
							});
							_this.box_arr_det = newarray;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {}
				});
			},
			// 切换
			getRoomByChange: function(type) {
				let temp = this.box_item;
				this.box_item = [];
				this.get_room_by = type;
				this.getBoxNum(this.add_form.shop_id, type);
				this.box_item = temp;
			},
			// 全选
			boxAll: function() {
				let _this = this;
				_this.box_all = _this.c_box_all;
				if(!_this.box_all) { // 实现全选
					_this.box_item = [];
					_this.box_arr_det.forEach(function(item) {
						_this.box_item.push(item.id);
					});
				} else { // 实现反选
					_this.box_item = [];
				}
			},
			// 楼层全选/反选
			boxFloor: function(id, index) {
				let _this = this;

				_this.box_floor = _this.c_box_floor;
				if(_this.box_floor.indexOf(id) == -1) {
					$.each(_this.box_arr[index].room, function(k, v) {
						if(_this.box_item.indexOf(v.id) == -1) {
							_this.box_item.push(v.id);
						}
					});
				} else {
					$.each(_this.box_arr[index].room, function(k, v) {
						let index = '';
						index = _this.box_item.indexOf(v.id);
						if(index != -1) {
							_this.box_item.splice(index, 1);
						}
					});
				}
			},
			// 确定包厢
			saveBox: function() {
				if(this.box_all) {
					this.room_ids_str = '全部包厢';
					this.add_form.all_room_ids = '1';
				} else {
					let texts = [];
					this.box_arr_det.forEach(item => {
						this.box_item.forEach(sub => {
							if(item.id == sub) {
								texts.push(item.name);
							}
						});
					});
					this.room_ids_str = texts.join(",");
					this.add_form.all_room_ids = '-1';
				}
				this.add_form.room_ids = this.box_item
				this.showBox = false;
			},
			// 返回
			boxBackEdit: function() {
				this.get_room_by = this.c_get_room_by;
				this.box_item = this.c_box_item;
				this.getBoxNum(this.add_form.shop_id, this.get_room_by);
				this.showBox = false;
			},
			clearRoomIds() {
				this.room_ids_str = ''
				this.box_item = []
				this.add_form.room_ids = []
				this.add_form.all_room_ids = '-1'
			},

			// 点击包厢类型
			openRoomTypePop: function() {
				let _this = this;

				let c_boxtype_item = _this.boxtype_item;
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['包厢类型', true],
					area: ['600px', ''], // 宽高
					content: $(_this.$refs.boxtype_pop),
					cancel: function() {
						// 右上角关闭
						if(_this.add_form.room_types != "") {
							_this.boxtype_item = c_boxtype_item;
							return;
						}
						_this.boxtype_item = [];
					}
				}, function() {
					if (_this.boxtype_all) {
						_this.room_types_str = '全部包厢类型';
						_this.add_form.all_room_types = '1';
					}else {
						let texts = [];
						_this.room_type_list.forEach(function(item) {
							_this.boxtype_item.forEach(function(item2) {
								if(item.id == item2){
									texts.push(item.name);
								}
							});
						});
						_this.room_types_str = texts.join(",");
					}
					_this.add_form.room_types = _this.boxtype_item
					layer.closeAll();
				}, function() {
					if(_this.add_form.room_types != "") {
						_this.boxtype_item = c_boxtype_item;
						return;
					}
					_this.boxtype_item = [];
				});
			},
			// 全选
			boxtypeAll: function() {
				let _this = this;

				_this.boxtype_all = _this.c_boxtype_all;
				if(!_this.boxtype_all) { // 实现全选
					_this.boxtype_item = [];
					_this.room_type_list.forEach(function(item) {
						_this.boxtype_item.push(item.id);
					});
				} else { // 实现反选
					_this.boxtype_item = [];
				}
			},
			clearRoomTypes() {
				this.room_types_str = ''
				this.boxtype_item = ''
				this.add_form.room_types = []
				this.add_form.all_room_types = '-1'
			},

			//使用时间弹窗
			openUseTimePop: function() {
                const _this = this

				_this.hour_start = _this.add_form.start_time.split(':')[0] || '00'
				_this.minute_start = _this.add_form.start_time.split(':')[1] || '00'
				_this.hour_end = _this.add_form.end_time.split(':')[0] || '00'
				_this.minute_end = _this.add_form.end_time.split(':')[1] || '00'
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '使用时间',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.usetime_pop)
				}, function() {
					_this.add_form.start_time = _this.hour_start + ":" + _this.minute_start
					_this.add_form.end_time = _this.hour_end + ":" + _this.minute_end
					_this.use_time_str = _this.add_form.start_time + '-' + _this.add_form.end_time
					layer.closeAll()
				})
			},
			clearUseTime() {
				this.use_time_str = ''
				this.add_form.start_time = ''
				this.add_form.end_time = ''
			},

			// 星期几弹窗
            openWeekPop() {
				const _this = this
                const c_week_ids = _this.week_ids,
                    c_week_sign = _this.week_sign,
                    c_week_all = _this.week_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择星期', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.week_pop),
                    cancel: function() {
                        // 右上角关闭
                        _this.week_ids = c_week_ids;
                        _this.week_sign = c_week_sign;
                        _this.week_all = c_week_all;
                    }
                }, function() {
                    let arr = [];
                    _this.week_list.forEach(item => {
                        _this.week_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.week_str = arr.join(',');
                    _this.add_form.week_cycle = _this.week_ids.join(",")
                    layer.closeAll();
                }, function() {
                    _this.week_ids = c_week_ids;
                    _this.week_sign = c_week_sign;
                    _this.week_all = c_week_all;
                });
            },
            weekAll(val) {
                let ids = []
				this.week_list.forEach(v => {
					ids.push(v.id)
				});
				this.week_ids = val ? ids : []
				this.week_sign = false
			},
			weekChange(val) {
				const len = val.length
				this.week_sign = len > 0 && len < this.week_list.length
				this.week_all = len === this.week_list.length
			},
			clearWeek() {
				this.week_sign = false
                this.week_all = false
				this.week_ids = []
				this.week_str = ''
				this.add_form.week_cycle = ''
			},

			// 打开商品选择面板
			openPickGoodsPanel() {
				this.getGoodsPackageType()
				this.showPickGoods = true
			},
			// 打开商品选择弹窗
			openPickGoodsPop() {
				const _this = this;

				_this.goods_type_sign = '';
				_this.goods_type = '';
				_this.goods_type_name = '';
				_this.goods_name = '';
				_this.getPopGoodsTable(1);
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择必点商品', true],
                    area: ['700px', '560px'], // 宽高
                    content: $(_this.$refs.good_pick_pop)
                }, function() {
					// 保存商品
					if(_this.goods_type_sign == 'package') {
						_this.goods_table_select.forEach(_ => {
							let isHad = false;
							for(let i = 0; i < _this.goods_select.length; i++) {
								if(_this.goods_select[i].goods_id == _.id && _this.goods_select[i].goods_type == '0') {
									isHad = true;
								}
							}
							if(!isHad) {
								_this.goods_select.push({
									"goods_id": _.id,//商品id 
				                    "goods_name": _.name,//商品名称
				                    "goods_type": _.goods_type,//商品类型id 套餐的则为对应套餐类型id
				                    "goods_type_name": _.goods_type_name,//类型名称
				                    "type": 2,//1商品 2套餐
				                    "good_img": _.img_url,//商品图片
				                    "goods_unit": _.package_unit,//单位id
				                    "goods_unit_name": _.package_unit_name,//单位
				                    "actual_price": -1,//修改的价格 如果没有修改则传-1
				                    "quantity": "" //数量
								})
							}
						})
					} else {
						_this.goods_table_select.forEach(_ => {
							let isHad = false;
							for(let i = 0; i < _this.goods_select.length; i++) {
								if(_this.goods_select[i].goods_id == _.id && _this.goods_select[i].goods_type == _.goods_type) {
									isHad = true;
								}
							}
							if(!isHad) {
								_this.goods_select.push({
									"goods_id": _.id,//商品id 
				                    "goods_name": _.goods_name,//商品名称
				                    "goods_type": _.goods_type,//商品类型id 套餐的则为对应套餐类型id
				                    "goods_type_name": _.goods_type_name,//类型名称
				                    "type": 1,//1商品 2套餐
				                    "good_img": _.good_img,//商品图片
				                    "goods_unit": _.goods_unit,//单位id
				                    "goods_unit_name": _.goods_unit_name,//单位
				                    "actual_price": -1,//修改的价格 如果没有修改则传-1
				                    "quantity": "" //数量
								})
							}
						})
					}
					// _this.$refs.pop_table.clearSelection();
					_this.panel_total = _this.goods_select.length
					_this.updatePanelTable()
					layer.msg('保存成功');
                });
			},
			// 获取商品套餐类型列表 
			getGoodsPackageType() {
				const _this = this;

				_this.goods_type_list = [{
					id: "-2",
					name: "商品套餐",
					type: 'package',
					type_id: ''
				}];
				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goods_type_list.push({
								id: '-2' + v.id,
								name: v.name,
								type: 'package',
								type_id: v.id
							});
						});
						_this.getGoodsType();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 获取商品类型列表
			getGoodsType: function() {
				const _this = this;

				Vue.axios.post('PublicData/api_getGoodsType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goods_type_list.push({
								id: v.id,
								name: v.name
							});
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			//切换商品类型
			goodsTypeChange(val) {
				this.goods_type_sign = val.type;
				if(this.goods_type_sign == 'package') {
					this.goods_type = val.type_id;
					this.goods_type_name = val.name;
				} else {
					this.goods_type = val.id;
					this.goods_type_name = val.name;
				}
				this.getPopGoodsTable(1);
			},
			getPopGoodsTable: function(page) {
				const _this = this;

				_this.pop_loading = true;
				_this.pop_page = page;
				let url = "merchantGoods/searchMerchantGoodsList";
				let data = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZEMINI,
							"shop_id": _this.add_form.shop_id,
							"goods_type": _this.goods_type,
							"goods_name": _this.goods_name,
						}
					},
					"comment": ""
				};
				if(_this.goods_type_sign == 'package') {
					url = "merchantGoods/searchMerchantGoodsPackage";
					data.request.param.status = '1';
				}
				Vue.axios({
					method: 'post',
					url: url,
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.pop_total = Number(res.data.response.result.data.total);
						}
						if(_this.goods_type_sign == 'package') {
							_this.goods_columns = [{
								"prop": 'name',
								"label": '名称'
							}, {
								"prop": 'package_unit_name',
								"label": '单位'
							}]
						} else {
							_this.goods_columns = [{
								"prop": 'goods_name',
								"label": '名称'
							}, {
								"prop": 'goods_unit_name',
								"label": '单位'
							}]
						}
						_this.pop_table = res.data.response.result.data.rows;
						_this.pop_loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			// 获取弹窗选择的商品
			getSelectGoods(val) {
				this.goods_table_select = val
			},
			// 更新商品选择面板表格
			updatePanelTable() {
				// 计算起始索引和结束索引
				let startIndex = (this.panel_page - 1) * this.GLOBAL.PAGESIZE;
				let endIndex = startIndex + this.GLOBAL.PAGESIZE;

			  	// 截取数据
			  	let slicedData = this.goods_select.slice(startIndex, endIndex);
			  	this.panel_table = slicedData
			},
			getPanelTable(page) {
				this.updatePanelTable()
			},
			// 删除商品
			delGoods(row, index) {
				let _this = this
				
				layer.confirm("确定删除该商品吗？", {
					btn: ['确定', '取消'], //按钮
				}, function() {
					let delIndex = (_this.panel_page - 1) * _this.GLOBAL.PAGESIZE + index
					_this.goods_select.splice(delIndex, 1)
					_this.updatePanelTable()
					layer.closeAll();
					layer.msg("操作成功！")
				});
			},
			// 保存挑选的商品
			savePickGoods() {
				if (this.goods_select.length < 1) {
					this.goods_name_str = ''
					this.add_form.goods_info = []
					this.showPickGoods = false
				}else {
					let pickGoods = []
					let isCompleted = true
					$.each(this.goods_select, (index, item) => {
						pickGoods.push(item.goods_name)
						if (item.quantity - 0 < 1) {
							isCompleted = false
						}
					})
					if (!isCompleted) {
						layer.msg('商品数量需要大于0');
					}else {
						this.goods_name_str = pickGoods.join(',')
						this.add_form.goods_info = this.goods_select
						this.showPickGoods = false
					}
				}
			},
			clearPickGoods() {
				this.goods_name_str = ''
				this.goods_select = []
				this.panel_table = []
			},

			// 提交设置
			commit() {
				let _this = this
				let url = _this.modify == '1' ? 'MustOrderItems/editData' : 'MustOrderItems/addData'
				Vue.axios.post(url, {
                    "header": Vue.request_header,
                    "request": {
                    	"version": '1.0',
                        "param": _this.add_form
                    },
                    "comment": ""
                })
                .then(res => {
                    layer.closeAll()
                    if(res.data.response.result_code == "true") {
                        layer.msg('操作成功');
                        if (_this.modify == '') {
                        	_this.page == 1
                        }
                        _this.getList(_this.page);
                        _this.showList = true
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
			},

			// 获取详情
			getDetail(id) {
				let _this = this

				Vue.axios.post('MustOrderItems/getData', {
                    "header": Vue.request_header,
                    "request": {
                    	"version": '1.0',
                        "param": {
                        	"id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    layer.closeAll()
                    if(res.data.response.result_code == "true") {
                        _this.add_form = res.data.response.result
                        // 包厢
                        _this.box_item = []
						if (_this.add_form.all_room_ids == '1') {
							_this.room_ids_str = "全部包厢"
							_this.box_arr_det.forEach(function(item) {
								_this.box_item.push(item.id);
							});
						}else {
							if (_this.add_form.room_ids.length < 1) {
								_this.room_ids_str = ""
							}else {
								let texts = [];
								_this.box_arr_det.forEach(item => {
									_this.add_form.room_ids.forEach(sub => {
										if(item.id == sub) {
											texts.push(item.name);
										}
									});
								});
								_this.room_ids_str = texts.join(",");
							}
							_this.box_item = _this.add_form.room_ids;
						}
						// 包厢类型
						if (_this.add_form.all_room_types == '1') {
							_this.room_types_str = "全部包厢类型"
							_this.room_type_list.forEach(function(item) {
								_this.boxtype_item.push(item.id)
							})
						}else {
							if (_this.add_form.room_types.length < 1) {
								_this.room_types_str = ""
							}else {
								let texts = [];
								_this.room_type_list.forEach(function(item) {
									_this.add_form.room_types.forEach(function(item2) {
										if(item.id == item2){
											texts.push(item.name);
										}
									});
								});
								_this.room_types_str = texts.join(",");
							}
							_this.boxtype_item = _this.add_form.room_types
						}
						// 使用时间
						_this.use_time_str = _this.add_form.start_time + '-' + _this.add_form.end_time
						// 星期几
						_this.week_ids = _this.add_form.week_cycle.split(",")
						_this.week_sign = _this.week_ids.length > 0 && _this.week_ids.length < _this.week_list.length
						_this.week_all = _this.week_ids.length === _this.week_list.length
						let arr = []
						_this.week_list.forEach(item => {
	                        _this.week_ids.forEach(sub => {
	                            if(item.id == sub) {
	                                arr.push(item.name);
	                            }
	                        });
	                    });
	                    _this.week_str = arr.join(',');
						// 必点商品
						_this.goods_name_str = _this.add_form.goods_str
						_this.goods_select = _this.add_form.goods_info
						_this.panel_page = 1
						_this.updatePanelTable()
                        _this.showList = false
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
			},

			// 详情
			checkDetail(id) {
				this.modify = 2
				this.getDetail(id)
			},

			editRule(id) {
				this.modify = 1
				this.getDetail(id)
			},
		}
    }
</script>
<style lang="less" scoped>
    .add-panel {
    	h2 {
    		margin: 20px 20px 40px 20px;
    	}
    	.el-input,
    	.el-select {
    		width: 500px;
    	}
    }
    .box-page {
		.box-type {
			margin: 30px 0;
			li {
				float: left;
				width: 130px;
				height: 40px;
				border: 1px solid #CCC;
				margin: 0 30px 0 0;
				line-height: 40px;
				color: #CCC;
				text-align: center;
				cursor: pointer;
			}
		}
	}
	.week-pop {
		.el-checkbox {
			margin-bottom: 10px;
		}
	}
	.good-pick-panel {
		h2 {
			text-align: center;
		}
		.panel-table {
			img {
				width: 50px;
			}
		}
		.good-pick-pop {
			.el-input,
			.el-select {
				width: 260px;
			}
		}
	}
</style>